module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/propertyPins-home-default@2x-af13dbad870fbc5c4a6840863ab20bae.png";